import React, { useState } from 'react';
import { Form, Input, Button, Table, Checkbox, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FullHeightContainerLayout } from 'components';
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;
const { Option } = Select;

// Row fields mirror what the business area service stores and returns for an assigned api key.
const BusinessAreaApiKeyList = ({ formRef, apiKeyList, apiKeys, onApiKeyChange, readOnly, onDeleteApiKey, getFormErrors, add, remove }) => {
    const [scrollToLastRow, setScrollToLastRow] = useState(false);
    return (
        <FullHeightContainerLayout
            showHeader={false}
            showFooter={true}
            content={
                <Table size="small"
                    dataSource={apiKeys}
                    pagination={false}
                    scroll={{ y: "100vh" }}
                    className="form-table container-height-100"
                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_TABLE}>
                    <Column
                        width="5%"
                        title="No."
                        key="index"
                        render={(value, field, index) => index + 1}
                    />
                    <Column
                        title={"Name"}
                        render={(value, field, index) => {
                            return (
                                <>
                                <Form.Item
                                    {...field}
                                    name={[field.name, "apiKeyId"]}
                                    {...getFormErrors(`apiKeys.${field.name}.apiKeyId`)}>
                                    <Select
                                        data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_SELECT}
                                        showSearch
                                        placeholder="Search to Select"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={value => onApiKeyChange(value, field)}
                                        {...(() => (readOnly ? { open: false } : {}))()}>
                                        {apiKeyList.map(apiKey => (<Option key={apiKey.apiKeyId} value={apiKey.apiKeyId}>{apiKey.name}</Option>))}
                                    </Select>
                                </Form.Item>
                                <Form.Item {...field} name={[field.name, "name"]} hidden>
                                        <Input />
                                </Form.Item>
                                <Form.Item {...field} name={[field.name, "version"]} hidden>
                                    <Input />
                                </Form.Item>
                                </>
                            );
                        }}
                    />
                    <Column
                        width="6%"
                        title={"Add"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item
                                    {...field}
                                    name={[field.name, "canAdd"]}
                                    valuePropName="checked"
                                    initialValue={true}>
                                    <Checkbox disabled={readOnly}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_CAN_ADD_CHECKBOX}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="6%"
                        title={"View"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item
                                    {...field}
                                    name={[field.name, "canView"]}
                                    valuePropName="checked"
                                    initialValue={true}>
                                    <Checkbox disabled={readOnly}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_CAN_VIEW_CHECKBOX}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="6%"
                        title={"Edit"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item
                                    {...field}
                                    name={[field.name, "canEdit"]}
                                    valuePropName="checked"
                                    initialValue={true}>
                                    <Checkbox disabled={readOnly}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_CAN_EDIT_CHECKBOX}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="6%"
                        title={"Delete"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item
                                    {...field}
                                    name={[field.name, "canDelete"]}
                                    valuePropName="checked"
                                    initialValue={true}>
                                    <Checkbox disabled={readOnly}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_CAN_DEL_CHECKBOX}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="10%"
                        title={"Active"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item
                                    {...field}
                                    name={[field.name, "active"]}
                                    valuePropName="checked"
                                    initialValue={true}>
                                    <Checkbox disabled={readOnly}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_ACTIVE_CHECKBOX}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="5%"
                        render={(value, field, index) => {
                            return (
                                <FontAwesomeIcon
                                    icon={faTrashCan}
                                    className={!readOnly ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_LIST_DELETE_BUTTON}
                                    onClick={() => {
                                        if (!readOnly) onDeleteApiKey(field, () => remove(field.name));
                                    }} />
                            );
                        }}
                    />
                </Table>
            }
            footer={
                <Form.Item>
                    <Button
                        block
                        onClick={() => {
                            setScrollToLastRow(true);
                            add();
                        }}
                        disabled={readOnly}
                        data-testid={CypressTestIds.BUSINESS_AREA_CLIENT_ADD_BUTTON}>
                        <PlusOutlined />
                        {apiKeys.length === 0 ? "Add API key" : "Add another API key"}
                    </Button>
                </Form.Item>
            }>
        </FullHeightContainerLayout>
    );
}

export default BusinessAreaApiKeyList;
